if (!customElements.get('tag-filter')) {
  customElements.define(
    'tag-filter',
    class TagFilter extends HTMLSelectElement {
      constructor() {
        super();
    
        this.updateWidth();
        this.addEventListener('change', this.onChange);
      }
    
      updateWidth() {
        const value = this.options[this.selectedIndex].text;
        const width = theme.getElementWidth(this, value);
        this.style.setProperty('--width', `${width}px`);
      }
    
      onChange() {
        this.updateWidth();
        window.location.href = this.value;
      }
    }, { extends: 'select' }
  );
}
document.addEventListener('DOMContentLoaded', () => {
  const selector = '#shopify-section-{{ section.id }} .article-card__title';
  const applyClampState = () => {
    document.querySelectorAll(selector).forEach(el => {
      // remove then re-check (for responsive changes)
      el.classList.remove('is-clamped');
      // allow layout to settle
      const isClamped = el.scrollHeight - 1 > el.clientHeight; // small fudge
      if (isClamped) el.classList.add('is-clamped');
    });
  };

  applyClampState();
  window.addEventListener('resize', applyClampState);
});
